module.exports = __webpack_public_path__ + "img/zhangqiangfeng.03ae22e0.jpg";